// Editor de template em CONTEXTO LIVRE (§4.5 — rota
// /notification-center/templates/:templateUuid). A criação acontece
// no dialog da lista de Templates (POST /templates → uuid real).
import { useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"

import { AppBreadcrumb } from "@/components/layout/app-breadcrumb"
import { Header } from "@/components/layout/header"
import { FRONTEND_ROUTES } from "@/constants"
import { TemplateEditorWorkspace } from "@/features/notification-center"

export function NotificationTemplateEditorPage() {
  const { t } = useTranslation()
  const { templateUuid } = useParams<{
    templateUuid: string
  }>()

  const links = [
    {
      href: FRONTEND_ROUTES.DASHBOARD.href,
      label: t("sidebar.dashboard"),
    },
    {
      label: t("pages.notificationCenter.title"),
      href: FRONTEND_ROUTES.NOTIFICATION_CENTER.href,
    },
    {
      label: t(
        "pages.notificationCenter.templatesPage.breadcrumb"
      ),
      href: FRONTEND_ROUTES.NOTIFICATION_CENTER_TEMPLATES
        .href,
    },
    {
      label: t(
        "pages.notificationCenter.templateEditorPage.breadcrumb"
      ),
    },
  ]

  return (
    <main className="flex w-full flex-1 flex-col">
      <Header>
        <AppBreadcrumb links={links} />
      </Header>
      <section className="flex flex-1 flex-col gap-4 p-4 @container">
        {templateUuid && (
          <TemplateEditorWorkspace
            templateUuid={templateUuid}
            context="free"
          />
        )}
      </section>
    </main>
  )
}
